import { toast } from '@hum/common/src/modules/toast';
import { downloadCompanyFile, useApiMutation } from '@hum/api';
import { useState } from 'react';

export const useDownloadFile = (companyId?: string) => {
  const [file, setFile] = useState<any>();
  const { mutate: downloadFile } = useApiMutation(downloadCompanyFile, {
    onSuccess: (data) => {
      const url = data.downloadUrl;
      const anchor = document.createElement('a');
      anchor.href = url;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      setFile(data.file);
    },
  });

  const download = async (fileId: number) => {
    try {
      if (!companyId) {
        throw 'companyId is required';
      }
      downloadFile({ companyId, fileId });
      return file;
    } catch (error: any) {
      toast.error(error?.message || 'Failed to download file.');
    }
  };

  return { download };
};
